export const SPICES = [
  {
    slug: 'turmeric',
    name: 'Turmeric',
    latin: 'Curcuma longa',
    tagline: 'Farm-gate fingers from India’s turmeric belt — washed and polished to your market’s spec.',
    origin: 'Salem · Erode · Sangli, India',
    chip: 'Curcumin 2.5 – 5.0%',
    varieties: ['Double Polished', 'Single Polished', 'Washed', 'Unwashed', 'IPM Grade'],
    image:
      'https://images.unsplash.com/photo-1702041295331-840d4d9aa7c9?q=85&w=1600&auto=format&fit=crop',
    specs: [
      ['Curcumin content', '2.5 – 5.0%'],
      ['Moisture', '≤ 10%'],
      ['Forms', 'Dried fingers · Powder'],
      ['Packing', '25 – 50 kg jute / PP bags'],
    ],
  },
  {
    slug: 'cardamom',
    name: 'Cardamom',
    latin: 'Elettaria cardamomum',
    tagline: 'Bold green pods from high-altitude estates, graded to the millimetre.',
    origin: 'Idukki & Wayanad, India',
    chip: 'Bold & Extra Bold',
    varieties: ['6 mm', '7 mm', '8 mm Bold', '8.5 mm Extra Bold'],
    image:
      'https://images.pexels.com/photos/8217944/pexels-photo-8217944.jpeg?auto=compress&cs=tinysrgb&w=1600',
    specs: [
      ['Pod size', '6 – 8.5 mm'],
      ['Grade', 'Green · Bold · Extra Bold'],
      ['Moisture', '≤ 12%'],
      ['Packing', '5 / 10 kg export cartons'],
    ],
  },
];

export const SPICE_OPTIONS = ['Turmeric', 'Cardamom'];

export const TURMERIC_GRADES = [
  {
    name: 'Double Polished',
    short: 'Cleanest finish',
    body: 'Fingers pass through the polishing drum twice, removing all outer skin and root hair for a smooth, bright golden surface. Preferred by retail packers and export markets where appearance and uniformity sell the product.',
    fit: 'Retail packing · Premium export · Powder with bright colour',
  },
  {
    name: 'Single Polished',
    short: 'Balanced finish',
    body: 'One pass through the drum removes most skin and dust while keeping slightly more of the natural surface. A commercial standard that balances appearance with a lower processing cost per tonne.',
    fit: 'Bulk export · Grinding units · Wholesale',
  },
  {
    name: 'Washed',
    short: 'Natural surface',
    body: 'Fingers are cleaned of soil and dust with water after curing but are not polished. The skin remains, giving a duller, earthier look while preserving full weight and curcumin.',
    fit: 'Extraction · Oleoresin · Industrial grinding',
  },
  {
    name: 'Unwashed',
    short: 'As cured',
    body: 'Cured and sun-dried fingers straight from the yard, with no washing or polishing. The most economical form, sold by weight for buyers who process further in-house.',
    fit: 'Processors with own cleaning lines · Price-led volume',
  },
  {
    name: 'IPM Grade',
    short: 'Residue-controlled',
    body: 'Grown under Integrated Pest Management — controlled, documented crop protection with reduced chemical inputs — and tested for pesticide residues against destination-market limits (EU / FSSAI).',
    fit: 'EU & regulated markets · Food brands · Residue-sensitive buyers',
  },
];

